/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterContactusContentAddPost } from '../fn/contactus-content/api-master-contactus-content-add-post';
import { ApiMasterContactusContentAddPost$Params } from '../fn/contactus-content/api-master-contactus-content-add-post';
import { apiMasterContactusContentDeleteGet } from '../fn/contactus-content/api-master-contactus-content-delete-get';
import { ApiMasterContactusContentDeleteGet$Params } from '../fn/contactus-content/api-master-contactus-content-delete-get';
import { apiMasterContactusContentEditPost } from '../fn/contactus-content/api-master-contactus-content-edit-post';
import { ApiMasterContactusContentEditPost$Params } from '../fn/contactus-content/api-master-contactus-content-edit-post';
import { apiMasterContactusContentGetActiveGet } from '../fn/contactus-content/api-master-contactus-content-get-active-get';
import { ApiMasterContactusContentGetActiveGet$Params } from '../fn/contactus-content/api-master-contactus-content-get-active-get';
import { apiMasterContactusContentGetAllGet } from '../fn/contactus-content/api-master-contactus-content-get-all-get';
import { ApiMasterContactusContentGetAllGet$Params } from '../fn/contactus-content/api-master-contactus-content-get-all-get';
import { apiMasterContactusContentGetByCriteriaPost } from '../fn/contactus-content/api-master-contactus-content-get-by-criteria-post';
import { ApiMasterContactusContentGetByCriteriaPost$Params } from '../fn/contactus-content/api-master-contactus-content-get-by-criteria-post';
import { apiMasterContactusContentGetByIdGet } from '../fn/contactus-content/api-master-contactus-content-get-by-id-get';
import { ApiMasterContactusContentGetByIdGet$Params } from '../fn/contactus-content/api-master-contactus-content-get-by-id-get';
import { ContactusContent } from '../models/contactus-content';
import { ContactusContentApiRespModel } from '../models/contactus-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ContactusContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterContactusContentAddPost()` */
  static readonly ApiMasterContactusContentAddPostPath = '/api/Master/ContactusContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentAddPost$Response(params?: ApiMasterContactusContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactusContentApiRespModel>> {
    return apiMasterContactusContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentAddPost(params?: ApiMasterContactusContentAddPost$Params, context?: HttpContext): Observable<ContactusContentApiRespModel> {
    return this.apiMasterContactusContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactusContentApiRespModel>): ContactusContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentEditPost()` */
  static readonly ApiMasterContactusContentEditPostPath = '/api/Master/ContactusContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentEditPost$Response(params?: ApiMasterContactusContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactusContentApiRespModel>> {
    return apiMasterContactusContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentEditPost(params?: ApiMasterContactusContentEditPost$Params, context?: HttpContext): Observable<ContactusContentApiRespModel> {
    return this.apiMasterContactusContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactusContentApiRespModel>): ContactusContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentDeleteGet()` */
  static readonly ApiMasterContactusContentDeleteGetPath = '/api/Master/ContactusContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentDeleteGet$Response(params?: ApiMasterContactusContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterContactusContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentDeleteGet(params?: ApiMasterContactusContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterContactusContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentGetByIdGet()` */
  static readonly ApiMasterContactusContentGetByIdGetPath = '/api/Master/ContactusContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetByIdGet$Response(params?: ApiMasterContactusContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactusContent>> {
    return apiMasterContactusContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetByIdGet(params?: ApiMasterContactusContentGetByIdGet$Params, context?: HttpContext): Observable<ContactusContent> {
    return this.apiMasterContactusContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactusContent>): ContactusContent => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentGetAllGet()` */
  static readonly ApiMasterContactusContentGetAllGetPath = '/api/Master/ContactusContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetAllGet$Response(params?: ApiMasterContactusContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
    return apiMasterContactusContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetAllGet(params?: ApiMasterContactusContentGetAllGet$Params, context?: HttpContext): Observable<Array<ContactusContent>> {
    return this.apiMasterContactusContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactusContent>>): Array<ContactusContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentGetActiveGet()` */
  static readonly ApiMasterContactusContentGetActiveGetPath = '/api/Master/ContactusContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetActiveGet$Response(params?: ApiMasterContactusContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
    return apiMasterContactusContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContactusContentGetActiveGet(params?: ApiMasterContactusContentGetActiveGet$Params, context?: HttpContext): Observable<Array<ContactusContent>> {
    return this.apiMasterContactusContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactusContent>>): Array<ContactusContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterContactusContentGetByCriteriaPost()` */
  static readonly ApiMasterContactusContentGetByCriteriaPostPath = '/api/Master/ContactusContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContactusContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentGetByCriteriaPost$Response(params?: ApiMasterContactusContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
    return apiMasterContactusContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContactusContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContactusContentGetByCriteriaPost(params?: ApiMasterContactusContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<ContactusContent>> {
    return this.apiMasterContactusContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactusContent>>): Array<ContactusContent> => r.body)
    );
  }

}
